// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"6fdaf764","148":"bfa5da1e","176":"dbb315ac","524":"dfeb106f","596":"596867c1","784":"127ad908","840":"6a934180","868":"0882375c"}[chunkId] + ".chunk.css";
};